
import { Vue, Prop, Component } from "vue-property-decorator";
import ExpModel from "@/models/ExpModel";

import RootView from "./RootView";
import ExpCarousel from "@/components/ExpCarousel.vue";
import {LMap, LTileLayer, LControlZoom, LIcon, LControl} from 'vue2-leaflet';

@Component({
    components: {
        ExpCarousel,
        LMap,
        LTileLayer,
        LControlZoom,
        LIcon,
        LControl
    }
})
export default class EmploymentView extends RootView {
    expType = "";
    iconSize = 64;
    inProcess = false;

    mapCenter = [46.015027997029925,-73.14909971534128];
    mapZoom = 12;
    mapUrl = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
    mapAttribution = "&copy; <a href='https://openstreetmap.org/copyright'>OpenStreetMap contributors</a>";

    mapOptions = {
        zoomControl: false,
        dragging: false,
        touchZoom: false,
        scrollWheelZoom: false,
        doubleClickZoom: false,
        boxZoom: false,
        keyboard: false,
        tap: false,          // older mobile Safari handling
        zoomSnap: 0.1        // optional: smoother flyTo end positions
    };

    $refs!: {
        map: any
    }

    async mounted() {
        this.inProcess = false;
        await this.$store.dispatch("exp/load");
        const items = this.$store.state.exp.items;
        if (items.length) this.onExpBtnClicked(items[0]);
    }

    get mapitemSize(): number[] {
        return [this.iconSize, this.iconSize * 1.15];
    }

    get mapitemAnchor(): number[] {
        return [this.iconSize / 2, this.iconSize * 1.15];
    }

    async onExpBtnClicked(item: ExpModel) {
        if (this.inProcess) return;
        this.inProcess = true;
        let that = this;
        let map: any = this.$refs.map.mapObject;
        this.expType = item.code;
        map.flyTo(item.position, 12);
         map.once('moveend', function() {
            that.inProcess = false;
        });
    }
}
